document.addEventListener("DOMContentLoaded", function() {
  jQuery(".pcc-modal.island-tour-modal").each(function() {
    var $modal = jQuery(this);
    var $iframe = $modal.find("iframe");
    var url = $iframe.data("video-url");

    $modal.on("open.zf.reveal", loadIframe);
    $modal.on("closed.zf.reveal", resetIframe);

    function loadIframe() {
      $iframe.attr("src", url);
      $iframe.css("left", getImageCenter($iframe[0]));
    }

    function resetIframe() {
      $iframe.attr("src", "");
    }

    function getImageCenter(element) {
      var elWidth = element.clientWidth;
      var galleryWidth = $modal.find(".pcc-modal__slider")[0].clientWidth;
      return (galleryWidth / 2) - (elWidth / 2);
    }
  });
});